import React from 'react';
import clsx from 'clsx';

import { Box as StyledBox } from './wrappers';

interface IBox {
  children: React.ReactNode;
  className?: string;
  overhang?: boolean | 'mobile' | 'desktop' | 'panel';
  background?:
    | boolean
    | 'default'
    | 'highlight'
    | 'warning'
    | 'member'
    | 'info'
    | 'main'
    | 'success'
    | 'error'
    | 'productListing';
  border?: boolean;
  borderTop?: boolean;
  noSpacing?: boolean;
  padding?: 'none' | 'y' | 'x' | '1' | '2' | '3' | '4' | '5';
  rounded?: boolean;
  roundedX2?: boolean;
  shrink?: boolean;
  stretch?: boolean;
  height?: string;
}

const Box = ({
  background,
  border,
  children,
  className,
  noSpacing,
  overhang,
  padding,
  rounded,
  roundedX2,
  shrink,
  stretch,
  height,
  borderTop,
}: IBox) => (
  <StyledBox
    height={height}
    className={clsx(
      className,
      background && background !== 'highlight' && 'bg',
      background === 'highlight' && 'bg-highlight',
      background === 'warning' && 'bg-warning',
      background === 'member' && 'bg-member',
      background === 'main' && 'bg-main',
      background === 'info' && 'bg-info',
      background === 'success' && 'bg-success',
      background === 'error' && 'bg-error',
      border && 'border',
      borderTop && 'border-top',
      rounded && 'rounded',
      roundedX2 && 'rounded-x2',
      padding && `padding-${padding}`,
      overhang && (overhang === true ? 'overhang' : `overhang-${overhang}`),
      noSpacing && 'no-spacing',
      stretch && 'stretch',
      shrink && 'shrink',
    )}>
    {children}
  </StyledBox>
);

export default Box;
